import React, { Component } from 'react';
import { Bar as BarChart, Line } from 'components/Charts';
import { PropType as PolygotPropType } from 'redux-polyglot';
import PropTypes from 'prop-types';
import { Skeleton, Alert } from 'antd';
import moment from 'moment-timezone';
import LocationOccupancyProvider from 'components/Providers/LocationOccupancyProvider';
import { formatNumber } from 'components/CMSv2/formatHelpers';

class Bar extends Component {
  constructor(props) {
    super(props);
    const { p } = this.props;
    this.allGates = `${p.tt('all')} ${p.tt('gates')}`;
    this.state = {

    };
  }

  componentDidUpdate(prevProps) {
    const {
      result, handleUpdateItems, handleItemChange, gates, locationId,
    } = this.props;
    if (result && result !== prevProps.result) {
      let gatesArr = [];
      const gateSet = new Set();
      const sortedData = result.content.rows
        ? [...result.content.rows].sort((a, b) => gates[a[0]] - gates[b[0]]) : [];
      sortedData.forEach((arr) => {
        if (!gateSet.has(arr[0]) && gates[arr[0]]) {
          gatesArr.push(gates[arr[0]].toString());
          gateSet.add(arr[0]);
        }
      });
      gatesArr.sort((a, b) => a.match(/\d+/).length > 0 && b.match(/\d+/).length > 0 && (a.match(/\d+/)[0] - b.match(/\d+/)[0] || (a.match(/\d+/)[0] === b.match(/\d+/)[0] && a.localeCompare(b))));
      gatesArr = [this.allGates, ...gatesArr];
      handleUpdateItems(gatesArr);
    }

    if (locationId !== prevProps.locationId) {
      handleUpdateItems([]);
      handleItemChange('');
    }
  }

  render() {
    const {
      p, dimension, result, fetching, failed, error, selectedItem, gates,
    } = this.props;

    if (fetching) {
      return <Skeleton active />;
    }
    if (failed || error) {
      return <Alert message={p.t('errors.loading', { error })} type="error" />;
    }
    const xfmt = (x => moment(x).toDate());
    let d = [];
    if (selectedItem === '' || selectedItem === this.allGates) {
      d = result.content.rows
        ? [...result.content.rows].sort((a, b) => a[1].localeCompare(b[1])) : [];
    } else {
      const gateNumber = selectedItem;
      const zoneNumber = Object.keys(gates).find(x => gates[x] === gateNumber);

      d = result.content.rows
        ? [...result.content.rows].filter(x => parseInt(x[0], 10) === parseInt(zoneNumber, 10))
          .sort((a, b) => a[1].localeCompare(b[1]))
        : [];
    }
    const dataSet = new Set();
    const data = [];
    d.forEach((arr) => {
      if (dataSet.has(arr[1])) {
        data[data.length - 1][1] += arr[2];
        data[data.length - 1][2] += arr[3];
      } else {
        dataSet.add(arr[1]);
        data.push([arr[1], arr[2], arr[3]]);
      }
    });
    const labels = [...dataSet];
    const labels2 = labels.map(xfmt);
    const arrivals = [];
    const departures = [];
    data.forEach((arr) => {
      arrivals.push({ x: moment(arr[0]).toDate(), y: arr[2] });
      departures.push({ x: moment(arr[0]).toDate(), y: arr[1] });
    });
    const datasets = [
      {
        label: p.tt('enplanement.arrivals'),
        data: arrivals,
        backgroundColor: '#B8CFE4',
        pointBackgroundColor: '#B8CFE4',
        borderWidth: 2,
        borderColor: '#B8CFE4',
        pointRadius: arrivals.length > 30 ? 0 : undefined,
      },
      {
        label: p.tt('enplanement.departures'),
        data: departures,
        backgroundColor: '#4FD0D3',
        pointBackgroundColor: '#4FD0D3',
        borderColor: '#4FD0D3',
        borderWidth: 2,
        pointRadius: departures.length > 30 ? 0 : undefined,
      },
    ];
    if (dimension === 'minute') {
      const minData = { datasets, labels: labels2 };

      return (
        <div style={{ height: 315 }}>
          <Line data={minData} yFmtr={formatNumber} />
        </div>
      );
    }

    return (
      <div style={{ height: 315 }}>
        <BarChart
          datasets={datasets}
          labels={labels2}
          stacked
          yFmtr={formatNumber}
          yTicks
          xTimeUnit={['minute', 'hour'].includes(dimension) ? undefined : 'day'}
          xType="time"
          legend
        />
      </div>
    );
  }
}

Bar.propTypes = {
  p: PolygotPropType,
  dimension: PropTypes.string,
  result: PropTypes.object,
  error: PropTypes.any,
  fetching: PropTypes.bool,
  failed: PropTypes.bool,
  gates: PropTypes.object,
  handleUpdateItems: PropTypes.func,
  handleItemChange: PropTypes.func,
  selectedItem: PropTypes.string,
  locationId: PropTypes.number,
};

export default LocationOccupancyProvider(({
  locationId,
  startDate,
  endDate,
  dimension,
}) => ({
  name: 'enplanement_bar_chart',
  endpoint: 'occupancy',
  metrics: 'entries,exits',
  locationId,
  startTime: startDate,
  endTime: endDate,
  tags: 'gate',
  dimensions: dimension,
}))(Bar);
